module.exports = __webpack_public_path__ + "img/antes_despues_83.01a23d69.png";